export function getRuntimeEnvValue(key) {
  const k = typeof key === 'string' ? key.trim() : '';
  if (k.length === 0) {
    return null;
  }

  if (typeof window !== 'undefined' && window.env !== undefined && window.env !== null) {
    const rawWindowValue = window.env[k];
    const windowValue = typeof rawWindowValue === 'string' ? rawWindowValue.trim() : '';
    if (windowValue.length > 0 && windowValue.indexOf('${') < 0 && (windowValue.startsWith('__') === false || windowValue.endsWith('__') === false)) {
      return windowValue;
    }
  }

  let rawProcessValue = undefined;
  if (typeof process !== 'undefined' && process.env !== undefined && process.env !== null) {
    if (k === 'VUE_APP_THEME_URL') {
      rawProcessValue = process.env.VUE_APP_THEME_URL;
    } else {
      rawProcessValue = process.env[k];
    }
  }
  const processValue = typeof rawProcessValue === 'string' ? rawProcessValue.trim() : '';
  if (processValue.length > 0 && processValue.indexOf('${') < 0 && (processValue.startsWith('__') === false || processValue.endsWith('__') === false)) {
    return processValue;
  }

  return null;
}

export function getRuntimeThemeValue() {
  if (typeof window !== 'undefined' && window.location && window.location.search) {
    const params = new URLSearchParams(window.location.search);
    if (params.has('theme')) {
      return params.get('theme');
    }
  }
  return getRuntimeEnvValue('VUE_APP_THEME_URL');
}

export function normalizeThemeKey(themeValue) {
  const raw = typeof themeValue === 'string' ? themeValue.trim() : '';
  if (raw.length === 0) {
    return 'classic';
  }

  let name = raw;
  if (name.indexOf('/') >= 0) {
    const parts = name.split('/').filter(p => typeof p === 'string' && p.trim().length > 0);
    if (parts.length > 0) {
      name = parts[parts.length - 1];
    }
  }

  const queryIndex = name.indexOf('?');
  if (queryIndex >= 0) name = name.slice(0, queryIndex);
  const hashIndex = name.indexOf('#');
  if (hashIndex >= 0) name = name.slice(0, hashIndex);

  if (name.endsWith('-theme.css') === true) {
    name = name.slice(0, name.length - 10);
  } else if (name.endsWith('.css') === true) {
    name = name.slice(0, name.length - 4);
  }

  const normalized = name.trim().toLowerCase();
  return normalized.length === 0 ? 'classic' : normalized;
}

export function getActiveThemeKey() {
  const themeValue = getRuntimeThemeValue();
  return normalizeThemeKey(themeValue);
}


